import { render, staticRenderFns } from "./PlatformDisconnectRow.vue?vue&type=template&id=30f17035"
import script from "./PlatformDisconnectRow.vue?vue&type=script&lang=ts"
export * from "./PlatformDisconnectRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports